import React, { useMemo } from 'react';
import { useResponsive } from '@shared/utils/hooks/useResponsive';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';
import {
  StyledWrapper,
  StyledMediaContainer,
  StyledMediaContent,
  StyledMediaBackgroundImage,
  StyledTextContainer,
  StyledTextContent,
  StyledTextHed,
  StyledTextSubtitle,
  styles
} from './CatalogEmptyStateHero.styles';

export interface CatalogEmptyStateHeroProps
  extends Readonly<{
    title: string;
    description: string;
    backgroundImage: string;
    disableBackgroundGradient?: boolean;
    containerStyles?: CSSObject;
  }> {}

const CatalogEmptyStateHero = (props: CatalogEmptyStateHeroProps) => {
  const [isMobile] = useResponsive({ values: { mobile: true, tablet: false } }, false);
  const { title, description, backgroundImage, disableBackgroundGradient = false } = props;

  const background = useMemo(() => {
    const urlObject = new URL(backgroundImage);
    if (isMobile) {
      urlObject.searchParams.set('resize', 'w450');
    }
    return urlObject.toString();
  }, [backgroundImage, isMobile]);

  return (
    <StyledWrapper __css={styles.wrapper}>
      <StyledMediaContainer __css={styles.mediaContainer}>
        <StyledMediaContent __css={styles.mediaContent}>
          <StyledMediaBackgroundImage __css={styles.mediaBackgroundImage(background, disableBackgroundGradient)} />
        </StyledMediaContent>
      </StyledMediaContainer>
      <StyledTextContainer __css={{ ...styles.textContainer, ...props.containerStyles }}>
        <StyledTextContent __css={styles.textContent}>
          <StyledTextHed __css={styles.textHed}>{title}</StyledTextHed>
          <StyledTextSubtitle {...styles.textSubTitle} dangerouslySetInnerHTML={{ __html: description }} />
        </StyledTextContent>
      </StyledTextContainer>
    </StyledWrapper>
  );
};

export { CatalogEmptyStateHero };
